import {useState} from 'react'
import DeleteScriptModal from '../modals/DeleteScriptModal'
import { useNavigate } from 'react-router-dom'

const ScriptManaActionsMenu = ({row: script}: any) => {
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const navigate = useNavigate()
  return [
    {
      label: 'Edit',
      onClick: () => navigate(`/storefronts/script-manager/${script.id}/${script.name}`),
    },
    {
      label: 'Delete',
      onClick: () => setShowDeleteModal(true),
      render: showDeleteModal && (
        <DeleteScriptModal script={script} onClose={() => setShowDeleteModal(false)} />
      ),
    },
  ]
}

export default ScriptManaActionsMenu
